import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=1c1e5e72&scoped=true&"
import script from "./Company.vue?vue&type=script&lang=js&"
export * from "./Company.vue?vue&type=script&lang=js&"
import style0 from "@/styles/index.scss?vue&type=style&index=0&id=1c1e5e72&prod&lang=scss&scoped=true&"
import style1 from "./Company.vue?vue&type=style&index=1&id=1c1e5e72&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1e5e72",
  null
  
)

export default component.exports